import React from 'react';
import Hero from '../components/Hero';
import DrivingSection from '../components/DrivingSection';
import WeatherSection from '../components/WeatherSection';
import SitePartner from '../components/SitePartner';
import ShareSection from '../components/ShareSection';

const KingsCounty = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      <Hero 
        title="Kings County" 
        subtitle="Eastern Prince Edward Island"
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773310180/king_rkqdmr.jpg"
      />
      <div className="max-w-2xl mx-auto px-4 mt-6">
        <SitePartner />
        <div className="flex flex-col gap-8 mt-4">
          <WeatherSection 
            title="Today's Weather Montague" 
            delay={0.1} 
            headerClassName="bg-purple-700 text-white"
            link="https://weather.gc.ca/en/location/index.html?coords=46.167,-62.572"
            buttonText="Today's King's County Weather"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Montague_brj2mc.png"
          />
          <DrivingSection 
            title="Kings County Driving Conditions" 
            delay={0.2} 
            headerClassName="bg-orange-500 text-white"
            imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Driving_c1vsow.png"
            link="https://511.gov.pe.ca/roadconditions?filters%5B0%5D%5Bs%5D=Kings+County"
            buttonText="Check Live King's County Driving conditions"
          />
        </div>
        <ShareSection />
      </div>
    </div>
  );
};

export default KingsCounty;